"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var utils_1 = require("../utils");
var KeyBinder_1 = require("../../KeyBinder");
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.matchFound = function (binder, combinations) {
            _this.$submit.click();
        };
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            _this.checkValidity();
            onChange && onChange(e);
        };
        _this.onInvalid = function (e) {
            var onInvalid = _this.props.onInvalid;
            if (_this.state.isValid) {
                _this.setState({ isValid: false });
                _this.props.onValidityChange(false);
            }
            onInvalid && onInvalid(e);
        };
        _this.onSubmit = function (e) {
            utils_1.pauseEvent(e);
            var onSubmit = _this.props.onSubmit;
            onSubmit && onSubmit(e);
            return false;
        };
        _this.onKeyDown = function (e) {
            var _a = _this.props, onKeyDown = _a.onKeyDown, submitOnEnter = _a.submitOnEnter;
            if (!submitOnEnter && e.which === 13 && e.target.type !== "textarea") {
                e.preventDefault();
            }
            onKeyDown && onKeyDown(e);
        };
        _this.setRef = function (el) {
            _this.$form = el;
        };
        _this.checkValidity = function () {
            utils_1.caf(_this.rafId);
            /**
             * Requesting animation frame before checking validations.
             * this will let components dependent to this form context `refreshValidity`
             * after re render and after all components mounted/unmounted from the DOM.
             */
            _this.rafId = utils_1.raf(function () {
                if (!_this.$form) {
                    return;
                }
                /**
                 * The reason we're not using the `this.$form.checkValidity` method is because it
                 * will trigger the validity change for all input elements and will show
                 * validations and warning messages on each element even on first render,
                 * we don't want that, so we silently checking each elements `validity.valid` property.
                 */
                var elements = Array.prototype.slice.call(_this.$form.elements, 0);
                var invalidElements = elements.some(function (element) { return !element.validity.valid; });
                var isValid = !invalidElements;
                if (isValid !== _this.state.isValid) {
                    _this.setState({ isValid: isValid });
                    _this.props.onValidityChange(isValid);
                }
            });
        };
        _this.setSubmitRef = function (el) {
            _this.$submit = el;
        };
        _this.rafId = null;
        _this.$form = null;
        _this.$submit = null;
        _this.state = { isValid: true };
        _this.initialize();
        return _this;
    }
    Form.prototype.getChildContext = function () {
        return {
            isFormValid: this.state.isValid,
            refreshValidity: this.checkValidity
        };
    };
    Form.prototype.initialize = function () {
        var _a = this.props, submitKeyBindingKeys = _a.submitKeyBindingKeys, submitKeyBindingDelay = _a.submitKeyBindingDelay;
        if (submitKeyBindingKeys) {
            this.keyBinder = new KeyBinder_1.default({
                combinations: [{
                        keys: submitKeyBindingKeys,
                        delay: submitKeyBindingDelay
                    }]
            });
            this.keyBinder.delegate = this;
        }
    };
    Form.prototype.componentWillUnmount = function () {
        if (this.keyBinder) {
            this.keyBinder.destroy();
        }
    };
    Form.prototype.componentDidMount = function () {
        this.checkValidity();
    };
    Form.prototype.render = function () {
        var _a = this.props, children = _a.children, onValidityChange = _a.onValidityChange, submitOnEnter = _a.submitOnEnter, submitKeyBindingDelay = _a.submitKeyBindingDelay, submitKeyBindingKeys = _a.submitKeyBindingKeys, others = tslib_1.__rest(_a, ["children", "onValidityChange", "submitOnEnter", "submitKeyBindingDelay", "submitKeyBindingKeys"]);
        return (React.createElement("form", tslib_1.__assign({}, others, { ref: this.setRef, onChange: this.onChange, onInvalid: this.onInvalid, onSubmit: this.onSubmit, onKeyDown: this.onKeyDown }),
            React.createElement("input", { type: "submit", ref: this.setSubmitRef, style: { display: "none" } }),
            children));
    };
    Form.defaultProps = {
        onValidityChange: utils_1.noop
    };
    Form.childContextTypes = {
        isFormValid: PropTypes.bool,
        refreshValidity: PropTypes.func
    };
    return Form;
}(React.Component));
exports.default = Form;
